import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import user from "../images/user.jpg";

const ContactDetail = (props) => {
    const location = useLocation();
    const contactData = location.state;
    const { name, email } = contactData;
    return (
        <div className="main">
            <div className="ui card centered">
                <div className="image">
                    <img src={user} alt="user" />
                </div>
                <div className="content">
                    <div className="header">{name}</div>
                    <div className="description">{email}</div>
                </div>
            </div>
            <div className="center-div">
                <Link to="/">
                    <button className="ui button blue center">
                        Back to Contact List
                    </button>
                </Link>
            </div>
        </div>
    );
}

export default ContactDetail;